import { render, staticRenderFns } from "./ShoppingListSteps.vue?vue&type=template&id=371865cc"
import script from "./ShoppingListSteps.vue?vue&type=script&lang=js"
export * from "./ShoppingListSteps.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListSteps.vue?vue&type=style&index=0&id=371865cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports